const stickyBar = document.getElementById('stickyBar');
  const hero = document.querySelector('.hero');
  const currentParams = new URLSearchParams(window.location.search);
  if ([...currentParams].length){
    document.querySelectorAll('a[href="/products/spark"]').forEach((link) => {
      const target = new URL(link.getAttribute('href'), window.location.origin);
      currentParams.forEach((value, key) => {
        if (!target.searchParams.has(key)) target.searchParams.set(key, value);
      });
      link.setAttribute('href', `${target.pathname}${target.search}`);
    });
  }
  function checkSticky(){
    if (hero.getBoundingClientRect().bottom < 0){
      stickyBar.classList.add('visible');
    } else {
      stickyBar.classList.remove('visible');
    }
  }
  window.addEventListener('scroll', checkSticky, {passive:true});
  window.addEventListener('resize', checkSticky);
;(function(){document.documentElement.classList.add('amie-static-rendered');})();
